module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-180x180-295f46af0f9f47ca3a476f5dcd8a0f59.png";